import {makeRequest} from "js/make-request/make-request"
import {HtmlResponse} from "js/@types"
import {debounce} from "../debounce/debounce"

export {}

const searches = document.querySelectorAll<HTMLFormElement>(".--js-search")
searches.forEach(search => {
  const dropdown = search.querySelector(".--js-search-dropdown")
  const targetElement = search.querySelector(".--js-search-dropdown-target")
  const input = search.querySelector("input")

  if (!targetElement || !input) return

  const fetchForm = async () => {
    targetElement.classList.add("--loading")
    dropdown?.classList.toggle("d-none", !input.value)

    const url = input.value ? `${search.action}?${input.value}` : search.action

    const response = await makeRequest(url, {
      method: "GET",
    })

    targetElement.classList.remove("--loading")
    const json = await response.json()

    const data: HtmlResponse = JSON.parse(json)
    if (data.html) targetElement.innerHTML = data.html

  }

  input.addEventListener("input", debounce(fetchForm, 500))

  input.addEventListener("focus", () => {
    if (input.value) dropdown?.classList.remove("d-none")
  })

  document.addEventListener("click", ({target}) => {
    if (target instanceof Element && !target?.closest(".--js-search")) {
      dropdown?.classList.add("d-none")
    }
  })
})
